<template>
  <button
    data-sidebar="rail"
    data-slot="sidebar-rail"
    aria-label="Toggle Sidebar"
    :tabindex="-1"
    title="Toggle Sidebar"
    :class="
      cn(
        'group/rail hover:after:bg-border-base absolute inset-y-0 -right-4 z-20 hidden w-4 -translate-x-1/2 transition-all ease-linear after:absolute after:inset-y-0 after:left-1/2 after:w-[2px] sm:flex',
        'cursor-pointer in-data-[state=collapsed]:cursor-pointer',
        props.class,
      )
    "
    @click="toggleSidebar"
  >
    <div
      class="text-border-base bg-base-100 group-hover/rail:bg-base-200 absolute top-4 left-1/2 z-[21] flex size-9 -translate-x-1/2 items-center justify-center rounded-full border transition-all group-data-[state=collapsed]:top-11 hover:text-shadow-lg"
    >
      <Icon
        name="lucide:chevrons-right"
        class="size-5"
        :class="{ 'rotate-180': open }"
      />
    </div>
  </button>
</template>

<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { useSidebar } from "./utils";
import { cn } from "@/lib/utils";

const props = defineProps<{
  class?: HTMLAttributes["class"];
}>();

const { toggleSidebar, open } = useSidebar();
</script>
